import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ModalController, AlertController, LoadingController, NavController, ToastController } from 'ionic-angular';
import { Client } from '../../models/client';
import { ClientCreatePage } from '../../pages/client-create/client-create';
import { AddNotePage } from '../../pages/add-note/add-note';
import { Items } from '../../providers/providers';
import { SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
import { UserData } from '../../models/user';
import { UserAccount } from '../../models/account';
import { Assessment } from '../../models/assessment';
import { saveAs } from 'file-saver';
import { InternalNgModuleRef } from '@angular/core/src/linker/ng_module_factory';

/**
 * Generated class for the ClientDetailsComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'client-details',
  templateUrl: 'client-details.html'
})
export class ClientDetailsComponent {

  @Input() client: Client;
  @Input() text: string;
  @Output() updateClient: EventEmitter<Client> = new EventEmitter<Client>();
  @Output() addNewClient: EventEmitter<Client> = new EventEmitter<Client>();
  @Output() goBackToFront: EventEmitter<Client> = new EventEmitter<Client>();
  clientNotes: any[];
  pastResults: any[];
  clientSchedules: any[] = [];
  sentLogs: any[];
  futureLogs: any[];
  pdfLink: any;
  assigned_users: any[];
  assigned_groups: any[];
  userData: UserData;
  userAccountData: UserAccount;
  currentItems: Client[];
  assessments: Assessment[];
  better_access:boolean = false;
  clientId:string;
  user: any[];
  scheduleCount: number = 1;

  constructor(public navCtrl: NavController, public modalCtrl: ModalController, public items: Items,
    public alertCtrl: AlertController, public loading: LoadingController, public toastCtrl: ToastController) {
      // disable better access
      console.log('in');
  }

  checkToday(date) {
    var inputDate = new Date(date);
    var todaysDate = new Date();

    if(inputDate.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
      return true;
    } else {
      return false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      if (propName === 'client') {
        let client = changes['client'].currentValue;
        if (typeof client === 'undefined') {
          //do nothing
        } else {
          this.getClientDetail(client)
        }

      }

    }

  }

  getClientDetail(client) {
    var id = client.id ? client.id : client.clientId;
    let loading = this.loading.create({ spinner: 'circles', content: "Loading...", cssClass: 'activity-detail-loading', showBackdrop: false });
    loading.present()
      this.items.getClientNotesAndResponses(id).subscribe(res => {
        if (res) {
          this.client = res;
          this.user = res.user;
          this.clientNotes = res.notes;
          this.pastResults = res.responses;
          //this.clientSchedules = client.scheduleList;
          this.sentLogs = res.schedules.sent;
          this.clientSchedules = res.aschedules;
          this.futureLogs = res.schedules.scheduled;
          this.client.assigned_users = res.assigned_users;
          this.client.assigned_groups = res.assigned_groups;
          this.client.groupings = res.groupings;
          this.client.practitioners = res.practitioners;
          this.clientId = client.id;
          this.scheduleCount = 0
          if (this.clientSchedules) {
            this.clientSchedules.forEach(function(schedule) {
              schedule.expired = this.isExpired(schedule.next_send);
              schedule.client = client;
              if ((schedule.start_date != null && schedule.status == 0 && !schedule.expired) || schedule.start_date != null && (schedule.status == 3 || schedule.expired) || schedule.start_date != null && schedule.repeat_cycle != 0 && schedule.status == 2) {
                this.scheduleCount++;
              }
            }, this);
          }
          console.log(this.clientSchedules);
        }
        loading.dismiss()
      },
        err => {
          loading.dismiss()
          console.log(err);
        });
  }

  backToFront() {
    this.goBackToFront.emit(this.client)
  }

  administer() {
    let client = { clientId: this.client.id, clientName: this.client.first_name + " " + this.client.last_name, clientEmail: this.client.email, clientEmail2: this.client.parent_2_email };
    let modal = this.modalCtrl.create('SelectAssessmentPage', { client: client });
    modal.present();
  }

  emailAssessment() {
    let client = { clientId: this.client.id, clientFirstName: this.client.first_name, clientLastName: this.client.last_name, clientEmail: this.client.email, clientEmail2: this.client.parent_2_email, parentName1: this.client.parent_1_name, parentName2: this.client.parent_2_name };
    let modal = this.modalCtrl.create('EmailPage', { client: client });
    modal.onDidDismiss(data => {
      if (data) {
        let toast = this.toastCtrl.create({
          message: 'Assessment email sent',
          duration: 3000,
          position: 'top'
        });
        toast.present();
      }
    })
    modal.present();
  }

  scheduleAssessment() {
    let client = { clientId: this.client.id, clientFirstName: this.client.first_name, clientLastName: this.client.last_name, clientEmail: this.client.email, clientEmail2: this.client.parent_2_email, parentName1: this.client.parent_1_name, parentName2: this.client.parent_2_name };
    let modal = this.modalCtrl.create('SchedulePage', { client: client });
    modal.onDidDismiss(data => {
      if (data.dismiss == 'create') {
        let toast = this.toastCtrl.create({
          message: 'New scheduler created',
          duration: 3000,
          position: 'top'
        });
        toast.present();
        this.getClientDetail(this.client)
      }
    })
    modal.present();
  }

  addNote(clientId) {
    let modal = this.modalCtrl.create(AddNotePage, { clientId: clientId });
    modal.onDidDismiss(data => {
      if (data) {
        let item = data.item;

        if (data.action == 'save') {
          let seq = this.items.addNote({ clientId: clientId, title: item.title, body: item.body }).share();
          seq
            .map(res => res.json().data.note)
            .subscribe(res => {
              let toast = this.toastCtrl.create({
                message: 'New note created',
                duration: 3000,
                position: 'top'
              });
              toast.present();
              this.clientNotes.push(res);
            }, err => {
              console.error('ERROR', err);
            });
        }
      }
    })
    
    this.updateClient.emit(this.client);
    modal.present();
  }

  noteSelected(note, indexValue) {
    console.log('edit');
    let modal = this.modalCtrl.create(AddNotePage, { note: note });
    modal.onDidDismiss(data => {
      if (data) {
        let item = data.item;
        if (data.action == 'save') {
          let obj = { title: item.title, body: item.body, client_id: note.client_id, id: note.id }
          let seq = this.items.editNote(obj).share();
          seq
            .map(res => res.json().data.note)
            .subscribe(res => {
              this.clientNotes[indexValue] = res;
              let toast = this.toastCtrl.create({
                message: 'Note updated',
                duration: 3000,
                position: 'top'
              });
              toast.present();
            }, err => {
              console.error('ERROR', err);
            });
        } else if (data.action == 'delete') {
          let toast = this.toastCtrl.create({
            message: 'Note removed',
            duration: 3000,
            position: 'top'
          });
          toast.present();
          this.clientNotes.splice(indexValue, 1);
        }
      }
    })
    modal.present();
  }

  /**
   * Prompt the user to add a new item. This shows our ItemCreatePage in a
   * modal and then adds the new item to our data source if the user created one.
   */
  addClient() {
    this.items.getAccountDetails().subscribe(res => {
      if (res) {
        this.userAccountData = res;
        if (parseInt(this.userAccountData.max_clients) - this.userAccountData.client_count < 4 ||
          this.userAccountData.client_count > parseInt(this.userAccountData.max_clients)) {
          this.presentAlert();
        }
        else {
          let addModal = this.modalCtrl.create(ClientCreatePage, { userData: this.userAccountData }, { cssClass: "add-client-modal" });
          addModal.onDidDismiss(item => {
            if (item) {
              if (item.dismiss === 'done') {
                this.items.addClient(item.form).subscribe(res => {
                  if (res) {
                    console.log('asdas');
                    this.addNewClient.emit()
                  }
                }, err => {
                  console.error('ERROR', err);
                });

              }
            }
          })
          addModal.present();
        }
      }
    }, err => {
      console.error('ERROR', err);
    });
  }

  editClient(client) {
    this.userData = <UserData>JSON.parse(localStorage.getItem('userData'));
    let addModal = this.modalCtrl.create(ClientCreatePage, { client: client, userData: this.userData }, { cssClass: "add-client-modal" });
    addModal.onDidDismiss(item => {
      if (item) {
        if (item.dismiss === 'done') {
          let seq = this.items.editClient(item.form, client.id).share();
          seq
            .map(res => res.json().data.client)
            .subscribe(res => {
              this.client = res;
              this.updateClient.emit(this.client);
              this.getClientDetail(this.client)
            }, err => {
              console.error('ERROR', err);
            });
        } else if (item.dismiss === 'inactive') {
          client.inactive = 1;
          let seq = this.items.editClient(client, client.id).share();
          seq
            .map(res => res.json().data.client)
            .subscribe(res => {
              this.client = res;
              this.updateClient.emit(this.client);
              this.getClientDetail(this.client)
            }, err => {
              console.error('ERROR', err);
            });
        } else if (item.dismiss === 'delete') {
          client.active = "0";
          let seq = this.items.deleteClientStatic(client, client.id).share();
          seq
            .map(res => res.json().data.client)
            .subscribe(res => {                      
              this.navCtrl.push('clients')
            }, err => {
              console.error('ERROR', err);
            });
        }
      }
    })
    addModal.present();
  }

  editSchedule(schedule) {
    let addModal = this.modalCtrl.create('SchedulePage', { client: schedule.client, scheduledAssessment: schedule.assessments, schedule: schedule });
    addModal.onDidDismiss(item => {
      if (item) {
        if (item.dismiss === 'delete') {
          this.client.deleteSchedule = "0";
          let seq = this.items.deleteScheduleAssessments(schedule.id).share();
          seq
            .map(res => res.json().data.client)
            .subscribe(res => {
              let index = this.clientSchedules.findIndex(result => result.id === schedule.id);
              if (index > -1) {
                this.clientSchedules.splice(index, 1);
                this.scheduleCount = this.scheduleCount - 1
                //this.client.scheduleList = this.clientSchedules;
              }
              this.updateClient.emit(this.client);
              let toast = this.toastCtrl.create({
                message: 'Scheduler removed',
                duration: 3000,
                position: 'top'
              });
              toast.present();
            }, err => {
              console.error('ERROR', err);
            });
        } else if(item.dismiss == 'edit') {
          let toast = this.toastCtrl.create({
            message: 'Scheduler updated',
            duration: 3000,
            position: 'top'
          });
          toast.present();
          this.getClientDetail(this.client)
        }
      }
    })
    addModal.present();
  }

  deleteSchedule(schedule) {
    const prompt = this.alertCtrl.create({
      title: 'Delete Schedule',
      message: "Delete this schedule?",
      buttons: [
        {
          text: 'Delete',
          handler: data => {
            this.client.deleteSchedule = "0";
            let seq = this.items.deleteScheduleAssessments(schedule.id).share();
            seq
              .map(res => res.json().data.client)
              .subscribe(res => {
                let index = this.clientSchedules.findIndex(result => result.id === schedule.id);
                if (index > -1) {
                  this.clientSchedules.splice(index, 1);
                  this.scheduleCount = this.scheduleCount - 1
                  //this.client.scheduleList = this.clientSchedules;
                }
                this.updateClient.emit(this.client);
              }, err => {
                console.error('ERROR', err);
              });
          }
        },
        {
          text: 'Cancel',
          handler: data => {
            console.log('Saved clicked');
          }
        }
      ]
    });
    prompt.present();
  }

  viewSentLogs() {
    let modal = this.modalCtrl.create('SentLogsPage', { sentLogs: this.sentLogs });
    modal.present();
  }

  viewFutureLogs() {
    let modal = this.modalCtrl.create('FutureLogsPage', { futureLogs: this.futureLogs });
    modal.present();
  }

  getFormatedDate(date) {
    return moment(date).format("MMM Do YY");
  }

  getFormatedDOB(date) {
    return moment(date).format("DD/MM/YYYY");
  }

  itemSelected(id) {
    var popup = window.open('', "_blank");
    this.items.getReportURL(id).subscribe(data => {
      if (data) {
        popup.location.href = data.url
      }
    },
      error => {
        console.log(error);
      }
    );

  }

  downloadAssessment(item){
    console.log(item)
    this.items.getResultPDF(item.id).subscribe(data => {
      if (data) {
        saveAs(data, this.client.first_name + '_' + this.client.last_name + '_' + item.assessment_short_name + '_' + item.created.substring(0, 10))
      }
    },
      error => {
        console.log(error);
      }
    );
  }

  refreshAssessments() {
    let loading = this.loading.create({ spinner: 'circles', content: "Loading...", cssClass: 'activity-detail-loading', showBackdrop: false });
    loading.present()
      this.items.getClientNotesAndResponses(this.client.id).subscribe(res => {
        if (res) {
          this.pastResults = res.responses;
        }
        loading.dismiss()
      },
        err => {
          loading.dismiss()
          console.log(err);
        });
  }
  

  preadminister(assessmentId, action = 'assessment', is_parent_2 = "0"){
    // this.items.getAccountDetails().subscribe(res => {
    //   if (res) {
    //     this.userAccountData = res;
    //     if (parseInt(this.userAccountData.max_assessments) - parseInt(this.userAccountData.monthly_administered_assessments) < 4 ||
    //       parseInt(this.userAccountData.monthly_administered_assessments) > parseInt(this.userAccountData.max_assessments)) {
    //       this.presentAssessmentAlert(assessmentId);
    //     } else {
    //       this.items.getClientNotesAndResponses(this.clientId).subscribe(res => {
    //         if (res) {
    //           if (res.better_access === '1' && this.better_access) {
                let createSession = this.modalCtrl.create('CreateSessionPage', { clientId: this.clientId, manage: false });
                // createSession.onDidDismiss( data => {
                //   if (data) {
                //     if (data.dismiss === 'done') {
                //       let loading = this.loading.create({ spinner: 'hide', content: `<img src="assets/images/Loading.gif" />`, duration: 5000, cssClass: 'activity-detail-loading', showBackdrop: false, dismissOnPageChange: true });
                //       loading.present();
                //       this.items.addSession(data.form).subscribe(res => {
                //         if (res) {
                //           loading.dismissAll();
                //           if (action == 'email') {
                //             this.emailAgain(assessmentId);
                //           } else if (action == 'send') {
                //             this.emailAssessment();
                //           } else {
                //             this.doAgain(assessmentId);
                //           }
                //         }
                //       },
                //       err => {
                //         loading.dismissAll();
                //         console.log(err);
                //       });
                //     } else if (data.dismiss === 'skip') {
                //       if (action == 'email') {
                //         this.emailAgain(assessmentId);
                //       } else if (action == 'send') {
                //         this.emailAssessment();
                //       } else {
                //         this.doAgain(assessmentId);
                //       }
                //     }
                //   }
                // });
                // createSession.present();
              // } else {
                if (action == 'email') {
                  this.emailAgain(assessmentId);
                } else if (action == 'send') {
                  this.emailAssessment();
                } else {
                  this.doAgain(assessmentId, is_parent_2);
                }
              // }
  //           }
  //         },
  //           err => {
  //             console.log(err);
  //         });
  //       }
  //     }
  //   }, err => {
  //     console.error('ERROR', err);
  //   });
  }

  doAgain(assessmentId, is_parent_2) {
    var assessment = [];
    assessment.push(this.getAssessmentForId(assessmentId));
    this.navCtrl.push('administer', { clientName: this.client.first_name + " " + this.client.last_name, assessments: assessment, clientId: this.client.id, is_parent_2: is_parent_2,index:0, client: this.client })
  }

  //added on 26/09/2020
  emailAgain(assessmentId){
    let client = { clientId: this.client.id, clientName: this.client.first_name + " " + this.client.last_name, clientEmail: this.client.email, clientEmail2: this.client.parent_2_email, parentName1: this.client.parent_1_name, parentName2: this.client.parent_2_name };
    var assessment = this.getAssessmentForId(assessmentId);
    let modal = this.modalCtrl.create('EmailPage', { client: client, assessment: assessment });
    modal.onDidDismiss(data => {
      let toast = this.toastCtrl.create({
        message: 'Assessment email sent',
        duration: 3000,
        position: 'top'
      });
      toast.present();
    })
    modal.present();
 }

 editItem(assessmentId,reportId){
  var assessment = this.getAssessmentForId(assessmentId);
  let modal = this.modalCtrl.create('EditResultPage', {assessment: assessment,reportId: reportId, callback: this.getData, clientId: this.client.id}, { cssClass: "edit-result-modal" });
  modal.present();
 }
 getData = (data,date) => {
    return new Promise((resolve, reject) => {
      let index = this.pastResults.findIndex(result => result.id === data);
                if (index > -1 && date == null) {
                  this.pastResults.splice(index, 1);
                    resolve();
                }else{
                  this.pastResults[index].local_time = moment(date).format("YYYY-MM-DD h:mm A")
                }
    });
  };

  //assessments are stored in local storage on the main page so they should be available here
  getAssessmentForId(assessmentId){
    var data = localStorage.getItem("assessments");
    if(data){
      var assessments = JSON.parse(data);
      return assessments.find(x => x.id == assessmentId);
    }
    
  }

  getRepeatCycle(val) {
    switch (val) {
      case "1": {
        return "day";
      }
      case "2": {
        return "week";
      }
      case "3": {
        return "fortnight";
      }
      case "4": {
        return "month";
      }
      case "5": {
        return "3 months";
      }
      default: {
        break;
      }
    }
  }

  deleteReport(item) {
    let prompt = this.alertCtrl.create({
      // title: 'Enter Password',
      message: "Are you sure you want to delete this report?",
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
          }
        },
        {
          text: 'Yes',
          handler: data => {
            this.items.deleteReport(item).subscribe((resp) => {
              if (resp) {
                let index = this.pastResults.findIndex(result => result.id === item);
                if (index > -1) {
                  this.pastResults.splice(index, 1);
                }
              }
              // var filtered = this.pastResults.filter(function(el) { return el.id != item; }); 
              // this.pastResults = filtered;
            }, (err) => {

            })

          }
        }
      ]
    });
    prompt.present();
  }

  presentAlert() {
    let alert = this.alertCtrl.create({
      title: parseInt(this.userAccountData.max_clients) - this.userAccountData.client_count + ' clients left on your limit',
      subTitle: 'You are currently on the ' + this.userAccountData.chargebee_plan + ' Plan, which allows you to add ' + this.userAccountData.max_clients + ' clients. You have added ' + this.userAccountData.client_count + ' clients so far. ' + 'Would you like to upgrade your limit?',
      buttons: [
        {
          text: 'Later',
          handler: data => {
            if (this.userAccountData.client_count <= parseInt(this.userAccountData.max_clients)) {
              let addModal = this.modalCtrl.create(ClientCreatePage, { userAccount: this.userAccountData }, { cssClass: "add-client-modal" });
              addModal.onDidDismiss(item => {
                if (item.dismiss === 'done') {
                  this.items.addClient(item.form);
                }
              })
              addModal.present();
            }
          }
        },
        {
          text: 'Upgrade',
          handler: data => {
            this.navCtrl.push('account');
          }
        }
      ]
    });
    alert.present();
  }

  presentAssessmentAlert(assessmentId) {
    let alert = this.alertCtrl.create({
      title: parseInt(this.userAccountData.max_assessments) - parseInt(this.userAccountData.monthly_administered_assessments) + ' tests left on your limit',
      subTitle: 'You are currently on the ' + this.userAccountData.chargebee_plan + ' Plan, which allows you to have ' + this.userAccountData.max_assessments + ' tests. You have administered ' + this.userAccountData.monthly_administered_assessments + ' tests so far. ' + 'Would you like to upgrade to increase your limit?',
       buttons: [
        {
          text: 'Later',
          handler: data => {
            if (parseInt(this.userAccountData.monthly_administered_assessments) < parseInt(this.userAccountData.max_assessments)) {
              var assessment = [];
              assessment.push(this.getAssessmentForId(assessmentId));
              this.navCtrl.push('administer', { clientName: this.client.first_name + " " + this.client.last_name, assessments: assessment, clientId: this.client.id,index:0, client: this.client })
            }
          }
        },
        {
          text: 'Upgrade',
          handler: data => {
            this.navCtrl.push('account');
          }
        }
      ]
    });
    alert.present();
  }

  //added to show the age but it's not required as the label is changed to DOB
  getAge(date){
    return moment().diff(date, 'years');
  }

  isExpired(next) {
    var expired = new Date(next) < new Date(new Date().toDateString());
    return expired;
  }

}



// WEBPACK FOOTER //
// ./src/components/client-details/client-details.ts